import '../styles/app.scss';
import './polyfills';

import Expose from './modules/Expose';
import Overlays from './modules/overlays';
import popIn from './modules/pop-in';
import fluidText from './modules/fluid-text';
import languageSelector from './modules/language-selector';
import header from './modules/header';
import mobileMenu from './modules/navigation';
import subcatDrops from './modules/subcategory-dropdown';
import checkboxGroup from './modules/checkbox-group';
import latestFilters from './modules/latest-filters';
import searchFilters from './modules/search-filters';
import trainingFilters from './modules/search-filters-trainings';
import filterPosts from './modules/filter-posts';
import loadVideos from './modules/video-loaded';
import fluidIframe from './modules/fluid-iframe';
import tweetAction from './modules/tweet-action';
import categorySlider from './modules/category-slider';
import copyShare from './modules/copy-share';
import tabbedNav from './modules/tabbed-nav';
import browserDetector from './modules/browser-detector';
import collapsableBlock from './modules/collapsable-block';
import addFlickityToTabs from './modules/tabbed-content-flickity';
import initCarousels from './modules/carousel';
import tableOfContents from './modules/table-of-contents';
import readMoreBlock from './modules/read-more';
import initAZFilter from './modules/az-filter';
import initActualitesArchive from './modules/actualites-archive';
import { getUserLocationFromButton, getUserLocationFromForm } from './modules/localisation';
import enhanceJetpackFormPlaceholders from './modules/jetpack-form-fix';
import { calculator, hoverDonationMenu } from './modules/donation-calculator';
import petitionShareFeedback from './modules/social-network-clicked';
import petitionDonateFeedback from './modules/donate-clicked';
import {
  toggleFullFormPetition,
  submitCodeOrigine,
  initTunnelClhForm,
  stepperTunnelClh,
} from './modules/petition-form';
import { closeUrgentBanner } from './modules/urgent-banner';
import initJetpackForm from './modules/Form/jetpack-forms';
import edhFilters from './modules/search-filters-edh';
import mySpaceMenu from './modules/my-space-menu';
import mySpaceMobileMenu from './modules/my-space-mobile-menu';
import { pageMenu, stickyMenu } from './modules/page-menu';
import sliderBlock from './modules/slider';
import changezLeurHistoireSlider from './modules/changez-leur-histoire-slider';
import changeTheirHistoryToc from './modules/change-their-history-toc';
import clhFinalScreen from './modules/clh-final-screen';
import BackToTop from './modules/back-to-top';
import urgentRegister from './modules/Form/urgent-register-form';
import { emptyInputNewsletterLead, handleNewsletterSubmission } from './modules/newsletter';
import GoPetitionsForm from './modules/Form/go-petition-form';
import { closeAlertBanner } from './modules/alert-banner';
import Countdown from './modules/countdown-clh';

const App = () => {
  browserDetector();
  popIn();
  languageSelector();
  header();
  mobileMenu();
  Overlays();
  subcatDrops();
  checkboxGroup();
  latestFilters();
  searchFilters();
  trainingFilters();
  filterPosts();
  fluidIframe();
  tweetAction();
  categorySlider();
  copyShare();
  tabbedNav();
  loadVideos();
  collapsableBlock();
  addFlickityToTabs();
  initCarousels();
  tableOfContents();
  readMoreBlock();
  initAZFilter();
  initActualitesArchive();
  getUserLocationFromButton();
  getUserLocationFromForm();
  enhanceJetpackFormPlaceholders();
  calculator();
  petitionShareFeedback();
  petitionDonateFeedback();
  toggleFullFormPetition();
  submitCodeOrigine();
  initTunnelClhForm();
  closeUrgentBanner();
  initJetpackForm();
  edhFilters();
  hoverDonationMenu();
  mySpaceMenu();
  mySpaceMobileMenu();
  pageMenu();
  stickyMenu();
  sliderBlock();
  changezLeurHistoireSlider();
  changeTheirHistoryToc();
  clhFinalScreen();
  BackToTop();
  urgentRegister();
  emptyInputNewsletterLead();
  handleNewsletterSubmission();
  GoPetitionsForm();
  closeAlertBanner();
  Countdown();
  stepperTunnelClh();

  fluidText(document.getElementsByClassName('article-shareTitle'), 0.9);

  return {
    using: Expose(),
  };
};

/**
 * Export to `window.App.default()`.
 */
export default App;
